import { mapActions, mapGetters, mapState } from 'vuex';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    contentLoaderMixin,
  ],
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapGetters('leaderboards', ['selectedLeaderboard']),
    ...mapState('leaderboards', ['leaderboards', 'selectedLeaderboardId']),
  },
  methods: {
    ...mapActions('leaderboards', ['setSelectedLeaderboardId', 'getLeaderboards']),
    itemClassModifiers(item) {
      return {
        'leaderboards-levels__item': true,
        'leaderboards-levels__item--active': item.leaderBoardId === this.selectedLeaderboardId,
      };
    },
    onItemClick(item) {
      if (item.leaderBoardId !== this.selectedLeaderboardId) {
        this.setSelectedLeaderboardId(item.leaderBoardId);
      }
    },
  },
  created() {
    this.getLeaderboards()
      .then((data) => {
        this.isComponentReady = true;
        const shouldSetFirstLeaderboardAsDefault = !this.selectedLeaderboardId
          && (data || []).length > 0
          && this.isLayoutDesktop;

        if (shouldSetFirstLeaderboardAsDefault) {
          this.setSelectedLeaderboardId(data[0].leaderBoardId);
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/leaderboards/leaderboards-levels/leaderboards-levels.js